import createReducer from "./createReducer";
import { CONTENT_FEED_ACTIONS } from "./actions/ContentFeedActions";
import { addFiltering } from "./common/Filtering";
import { DEFAULT_RPP } from "utils/constants";

const DEFAULT_SORT = "time:desc";

const initialState = {
	items: [],
	isLoading: false,
	hasErrorLoading: false,
	totalPages: 0,
	totalItems: 0,
};

const UPDATES_HISTORY_ACTIONS = {
	FETCH_UPDATES_HISTORY_AJAX: CONTENT_FEED_ACTIONS.FETCH_UPDATES_HISTORY_AJAX,
	FETCH_UPDATES_HISTORY_SUCCESS: CONTENT_FEED_ACTIONS.FETCH_UPDATES_HISTORY_SUCCESS,
	FETCH_UPDATES_HISTORY_ERROR: CONTENT_FEED_ACTIONS.FETCH_UPDATES_HISTORY_ERROR,
	RESET_UPDATES_HISTORY: "RESET_UPDATES_HISTORY",
};

export const handlers = {
	[UPDATES_HISTORY_ACTIONS.FETCH_UPDATES_HISTORY_AJAX]: fetchUpdatesHistory,
	[UPDATES_HISTORY_ACTIONS.FETCH_UPDATES_HISTORY_SUCCESS]: fetchUpdatesHistorySuccess,
	[UPDATES_HISTORY_ACTIONS.FETCH_UPDATES_HISTORY_ERROR]: fetchUpdatesHistoryError,
	[UPDATES_HISTORY_ACTIONS.RESET_UPDATES_HISTORY]: resetUpdatesHistory,
};

function fetchUpdatesHistory(state, action) {
	return {
		...state,
		items: [],
		isLoading: true,
		hasErrorLoading: false,
	};
}

function fetchUpdatesHistorySuccess(state, action) {
	const { data } = action.payload;

	return {
		...state,
		items: data.data,
		totalPages: data.pages,
		totalItems: data.total,
		isLoading: false,
		hasErrorLoading: false,
	};
}

function fetchUpdatesHistoryError(state, action) {
	return {
		...state,
		isLoading: false,
		hasErrorLoading: true,
	};
}

function resetUpdatesHistory(state, action) {
	return {
		...initialState,
		filterInfo: state.filterInfo,
	};
}

export function clearUpdatesHistory() {
	return {
		type: UPDATES_HISTORY_ACTIONS.RESET_UPDATES_HISTORY,
	};
}

let reducerConfig = {
	typeRoot: "UPDATES_HISTORY",
	actionTypes: UPDATES_HISTORY_ACTIONS,
	actionCreators: {
		clearUpdatesHistory,
	},
	initialState,
	handlers,
};

reducerConfig = addFiltering(reducerConfig, { sort: DEFAULT_SORT, rpp: DEFAULT_RPP });

export default createReducer(reducerConfig.initialState, reducerConfig.handlers);
export const UpdatesHistory = reducerConfig.actionCreators;

